import TopUpsForm from '../components/organisms/FormCreateTopUps';
import TopUpsMutationProvider from '../context/TopUpsMutationContext';

const CreateTopUpsPage = () => {
  return (
    <TopUpsMutationProvider>
      <TopUpsForm />
    </TopUpsMutationProvider>
  );
};

export default CreateTopUpsPage;
